/**
 * CykelmakkerApi
 * CykelmakkerApi
 *
 * The version of the OpenAPI document: v3
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type ECaseReason = 'Defective' | 'Return';

export const ECaseReason = {
    Defective: 'Defective' as ECaseReason,
    Return: 'Return' as ECaseReason
};

